import React, { HTMLAttributes } from 'react';

const TrashCan = ({ className }: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="5 3 14 18.67"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.167 19.333A2.34 2.34 0 0 0 8.5 21.667h7a2.34 2.34 0 0 0 2.333-2.334V7.667H6.167v11.666ZM17.833 4.167H15.5l-.828-.829A1.177 1.177 0 0 0 13.855 3h-3.71c-.303 0-.607.128-.817.338l-.828.829H6.167A1.17 1.17 0 0 0 5 5.333 1.17 1.17 0 0 0 6.167 6.5h11.666A1.17 1.17 0 0 0 19 5.333a1.17 1.17 0 0 0-1.167-1.166Z"
      fill="#394555"
    />
  </svg>
);
export default TrashCan;
